import React from 'react';
import { Box, Typography, styled } from '@mui/material';
import UserInitialsAvatar from 'components/UserInitialsAvatar/UserInitialsAvatar';

export type ProfileHeaderProps = {
  initials: string;
  name: string;
  /** Pre-translated secondary line: "Day 103 on Wellframe". */
  subtitle: string;
};

const AVATAR_SIZE = 64;

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2.5),
}));

const ProfileAvatar = styled(UserInitialsAvatar)({
  width: AVATAR_SIZE,
  height: AVATAR_SIZE,
  fontSize: '1.5rem',
  fontWeight: 500,
});

const TextBlock = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  minWidth: 0,
  overflowWrap: 'anywhere',
}));

export const ProfileHeader: React.FC<ProfileHeaderProps> = ({ initials, name, subtitle }) => (
  <Container className="profile-header">
    <ProfileAvatar
      className="profile-header__avatar"
      initials={initials}
      hasGradientBackgroundColor
      aria-hidden
    />

    <TextBlock>
      <Typography
        className="profile-header__name"
        variant="title3"
        component="h2"
        fontWeight="medium"
        color="grey.900"
      >
        {name}
      </Typography>
      <Typography
        className="profile-header__subtitle"
        variant="callout"
        fontWeight="medium"
        color="grey.600"
      >
        {subtitle}
      </Typography>
    </TextBlock>
  </Container>
);
